import { inject, Injectable } from '@angular/core';
import { Endpoint } from '@pcp/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ExtensionAppApiService {
    private readonly endpoint = inject(Endpoint);

    // Push The Button (dd = "Drück Drauf") endpoints
    private readonly ddBaseUrl = '/api/dd';

    startPushTheButton(): Observable<void> {
        return this.endpoint.get<void>(`${this.ddBaseUrl}/start`);
    }

    stopPushTheButton(): Observable<void> {
        return this.endpoint.get<void>(`${this.ddBaseUrl}/stop`);
    }
}
